import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultFormDisplayText = {
    submitButtonLabel: 'Submit',
    cancelButtonLabel: 'Cancel'
};
export const formDisplayTextValidatorSchema = {
    submitButtonLabel: Validator.optional(nonEmptyStringValidator),
    cancelButtonLabel: Validator.optional(nonEmptyStringValidator)
};
